import { useEffect, useLayoutEffect, useRef } from 'react';

const useInterval = (callback, delay = 1000) => {
    const savedCallback = useRef(callback);

    useLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        const interval = setInterval(() => savedCallback.current(), delay);

        return () => {
            clearInterval(interval);
        };
    }, [delay]);
};

export default useInterval;
